export default __webpack_public_path__ + "072e40ff9add66df6c61738f7265a479.svg";